import {
	settleToTarget,
	getAdminBarOffset,
	disableScrollRestoration,
} from '../utils/scroll';

const CONTAINER_SELECTOR = '.wFormContainer, form[id^="tfa_"]';

const findContainer = () => document.querySelector(CONTAINER_SELECTOR);

const wasSubmitted = () =>
	new URLSearchParams(location.search).has('tfa_next');

const FormAssemblyScroll = {
	init() {
		if (!wasSubmitted()) return;
		if (!findContainer()) return;

		disableScrollRestoration();
		settleToTarget({
			getTarget: findContainer,
			offset: getAdminBarOffset(),
		});
	},
};

export default FormAssemblyScroll;
